// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autocomplete {
    width: 100%;
}
.popup {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 9;
    margin-top: -19px;
    max-height: 300px;
    overflow: auto;
    padding:0;
}
.listitem {
    cursor: pointer;
    width:auto;
    padding-left: 10px;
    padding-right: 10px;
}

.listitem:hover {
    background-color: var(--primary-color);
    color: white;
}
.drop{
    cursor:pointer;
}

.overlay-container {
    position: fixed;
    z-index: 1000;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/autocomplete/autocomplete.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;AACA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;AACf","sourcesContent":[".autocomplete {\n    width: 100%;\n}\n.popup {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    position: absolute;\n    z-index: 9;\n    margin-top: -19px;\n    max-height: 300px;\n    overflow: auto;\n    padding:0;\n}\n.listitem {\n    cursor: pointer;\n    width:auto;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.listitem:hover {\n    background-color: var(--primary-color);\n    color: white;\n}\n.drop{\n    cursor:pointer;\n}\n\n.overlay-container {\n    position: fixed;\n    z-index: 1000;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
